module.exports = __webpack_public_path__ + "media/images/products/demo/slideri1-2dc52f7b07bad44b584cb1c9ee89f784.jpg";